export function modalClubConfig() {
  const clubList = [
    {
      id: 'extracurricular_activity',
      name: '課外活動本部',
      pic: ['img_extracurricular_activity_01.jpg'],
      text: `課外活動本部は、さまざまな課外活動団体から代表者を選出・構成された組織です。課外活動全体の活性化を図ったり、各団体の活動を学生の視点で支えています。
      また、毎年2月に各団体の代表者が集まって合宿を行うリーダーズキャンプや、さくら祭などのイベントの企画・運営も行っています。`,
      record: ``,
      sns: {
        x: '',
        instagram: '',
      },
    },
    {
      id: 'festival',
      name: '⼤⼿前祭実⾏委員会',
      pic: ['club_c_img02.jpg'],
      text: `毎年11月に行われる学園祭に向けて企画や準備、運営を行っています。学内関係者だけではなく外部の企業に協力を仰ぎ、本格的なステージの運営も行います。`,
      record: ``,
      sns: {
        x: 'http://x.com/FestivalOtemae',
        instagram: 'https://www.instagram.com/festivalotemae/profilecard/?igsh=MXZjendsbWN5MXhmcA== ',
      },
    },
    {
      id: 'coop',
      name: '⽣協学⽣委員会',
      pic: ['img_coop_01.jpg'],
      text: `主な活動はさくら祭、学祭はもちろん、にしのみや市民祭りで出店を通して、地域との交流を深めています。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemae_seikyo',
        instagram: 'https://www.instagram.com/otemaegi/',
      },
    },
    {
      id: 'golf',
      name: 'ゴルフ部',
      pic: ['img_golf_01.jpg', 'img_golf_02.jpg'],
      text: `ゴルフは基本的に個人競技なので、それぞれが自分のスケジュールに合わせて練習しています。土・日は六甲国際ゴルフ倶楽部でキャディ業務の手伝いをしながらラウンド＆練習をさせてもらえます。勉強もしっかりやりながら、ゴルフも思い切りできる毎日。部員全員がプロをめざしてがんばっています。`,
      record: `2023年度秋　全国大学女子ゴルフ対抗戦　第6位`,
      sns: {
        x: '',
        instagram: '',
      },
    },
    {
      id: 'kyudo',
      name: '弓道部',
      pic: ['club_a_img02.jpg'],
      text: `弓道は難しい部分があるのも事実ですが、部員の大半が大学から弓道を始めているので、皆で同じスタートラインから気軽に始めることができます。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemaekyudou',
        instagram: 'https://www.instagram.com/otemae_kyudo/',
      },
    },
    {
      id: 'badminton',
      name: '男女バドミントン部',
      pic: ['club_a_img03.jpg'],
      text: `大学から始めた人から経験者まで幅広いプレイヤーがおり、楽しむ人もいれば、試合に出て上手くなりたいとういう人もいます。G棟（体育館）で毎週水曜、金曜に練習してます。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_badminton?igsh=MXNwNzBjN3oyeGI4eg==',
      },
    },
    {
      id: 'basketball',
      name: '女子バスケットボール部',
      pic: ['club_a_img04.jpg'],
      text: `私たちは、運動不足解消になればいいな〜程度の感覚で、楽しみながら活動してます！
      「運動部はしんどそうだけど、軽く体動かしたいな」「バスケに興味があるけど、キツすぎる練習はいやだな、、」という方、大歓迎です！（少人数でゆるく活動してるので、本気でやりたい人は物足りないかもです！）
      途中参加、途中帰宅OKですので、是非気軽に体験しに来てください！`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_girls_basketballclub/',
      },
    },
    {
      id: 'baseball',
      name: '準硬式野球部',
      pic: ['club_a_img05.jpg'],
      text: `経験者はもちろん、初心者の方でも優しく教えてくれる先輩がいて、みんな仲が良く楽しく野球することができます。春・秋にはリーグ戦があり、勝つことをめざすことはもちろん、試合を部員全員で楽しむことに取り組んでいます。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_junko/',
      },
    },
    {
      id: 'dance',
      name: 'ダンス部',
      pic: ['club_a_img06.jpg'],
      text: `春にはさくら祭、夏は部内発表、外部の大きなステージでの発表、秋には学祭、冬は卒業公演と年間を通して様々なイベントがあります。
      HIPHOPやJAZZ、GIRLS、KPOP、JPOP、踊ってみたなど様々なジャンルがり、自分のしたいジャンルを選んで踊ることができます。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/dance_kanbu/profilecard/?igsh=N3l5djIwYnV1dzAz',
      },
    },
    {
      id: 'tennis',
      name: '硬式テニス部',
      pic: ['club_a_img07.jpg'],
      text: `リーグ戦4部昇格をめざして練習をしています。西宮浜グランドで活動しており、月・水・木・土で練習ししています。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otc_tennis07/?hl=ja',
      },
    },
    {
      id: 'lacrosse',
      name: '男子ラクロス部',
      pic: ['club_a_img08.jpg'],
      text: `ラクロスは、スピード感とチームプレーが魅力で、初心者でも楽しみながら上達できる競技です。部員のほとんどが大学からラクロスを始めた初心者ですが、先輩やコーチがしっかりサポートをしています。
      目標に向かって恐れることなく一心に突き進んでいくという意味を込めた「勇往邁進」が今年のスローガンです。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otm.m.lax?igsh=cGRldmd5cmkyaDJw',
      },
    },
    {
      id: 'volleyball',
      name: 'バレーボール部',
      pic: ['club_a_img09.jpg'],
      text: `男女共に仲良く楽しく練習しています！`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_volley?igsh=MWgxanp5ZWd2aXp0aw==',
      },
    },
    {
      id: 'molkky_recreation',
      name: 'Otemae Molkky Recreation',
      pic: ['club_a_img10.jpg'],
      text: `モルックサークル「Teemöns」は、過去に大会3位入賞2回（うち1回は全国大会）の実績を持ちます。モルックは体力や筋力は必要なく誰でも世界をめざせる可能性を秘めた競技です。`,
      record: ``,
      sns: {
        x: 'https://x.com/OtemaeMolkky',
        instagram: 'https://www.instagram.com/otm_molkky_teemons/',
      },
    },
    {
      id: 'volunteer',
      name: 'ボランティア部',
      pic: ['club_b_img01.jpg'],
      text: `50名以上の大所帯で、子ども食堂や高齢者の方との交流会、近隣の保育園での手話教室、大学周辺の清掃活動、地域のお祭りへの出店や運営のサポートなど、さまざまなボランティア活動を行っています。

      活動を通して地域との連携を深めることで、幅広い世代との交流を促進し、地域社会の一員として貢献しています。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemaevolunteer',
        instagram: 'https://www.instagram.com/otemae_volunteer/',
      },
    },
    {
      id: 'music',
      name: '音楽部',
      pic: ['club_b_img02.jpg'],
      text: `学内やライブハウスでのバンド演奏が主な活動です。
      部員のほとんどが大学から楽器を始めていて、新しいことを始めたい人におすすめです。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemaeongaku',
        instagram: 'https://www.instagram.com/otemaeongaku',
      },
    },
    {
      id: 'light_music',
      name: '軽音楽部',
      pic: ['club_b_img03.jpg'],
      text: `バンド組んでみたい、楽器を弾いてみたいと、大学生になってから新しく楽器を始めた部員も数多く活躍しています。`,
      record: ``,
      sns: {
        x: 'https://x.com/otm48_',
        instagram: 'https://www.instagram.com/otm.keion/',
      },
    },
    {
      id: 'acoustic',
      name: 'アコースティックサウンド部',
      pic: ['club_b_img04.jpg'],
      text: `主に既存のアコースティックの曲を様々な楽器を使って演奏をしています。部員のほとんどが初心者からのスタートです。ライブ活動も数多く実施しています。`,
      record: ``,
      sns: {
        x: 'https://x.com/acosan_otemae',
        instagram: 'https://www.instagram.com/aco_san_otemae/',
      },
    },
    {
      id: 'drama',
      name: '演劇部',
      pic: ['club_b_img05.jpg'],
      text: `大手前大学演部「演劇★団子」です。
      年に2,3回の公演に向けて日々稽古に励んでおり、現部員は大学から演劇を始めた人が半数以上で、役者そして裏方とやってみたい役職に挑戦しています。`,
      record: ``,
      sns: {
        x: 'https://x.com/engekidango',
        instagram: 'https://www.instagram.com/engekidango',
      },
    },
    {
      id: 'orchestral',
      name: '管弦楽部',
      pic: ['club_b_img06.jpg'],
      text: `週に2回活動を行っており、部員のほとんどが大学に入学してから弦楽器に初めました。
      少人数を活かし、部員それぞれに向き合いながら練習を行っています。学校の楽器を借りることもできます。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemae_kangen',
        instagram: 'https://www.instagram.com/otemae_kangen',
      },
    },
    {
      id: 'visual_culture',
      name: '現代視覚文化研究部',
      pic: ['club_b_img07.jpg'],
      text: `略して『げんしけん』。簡単に言えばオタクの部活です。
      普段はボードゲーム、イラスト、Switch、オタク雑談をするなどの活動をしています。`,
      record: ``,
      sns: {
        x: 'https://x.com/gensiken2021',
        instagram: 'https://www.instagram.com/genshiken23?igsh=MXh5cGZuZHgzYnF3Mw%3D%3D&utm_source=qr',
      },
    },
    {
      id: 'tea_ceremony',
      name: '茶道部',
      pic: ['club_b_img08.jpg'],
      text: `月1回程度外部から茶道の先生をお招きして指導をしていただいています。また、部室は専用の和室のため、リラックスして作法の練習などを行うことができ、温かい抹茶や菓子を楽しむことも可能です。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemae_sadou?t=dKijvWgkGSf6yEUhAMMaJw&s=09',
        instagram: 'https://www.instagram.com/otemae_sadou_bu/profilecard/?igsh=bG1ua2dpM3lzdHl3',
      },
    },
    {
      id: 'picture',
      name: '写真部',
      pic: ['club_b_img09.jpg'],
      text: `主な活動は撮影会で、夏には合宿があります。みんなで⾏きたい場所、撮りたいものを決めて撮影をしています。また、他の部活から撮影依頼を受けたり、地域のイベントも参加をしています。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemae_photo?lang=ja',
        instagram: 'https://www.instagram.com/otemae_photo/',
      },
    },
    {
      id: 'broadcast',
      name: '放送部',
      pic: ['club_b_img10.jpg'],
      text: `音声作品や映像作品を作成し発表しています。音声作品はラジオ・ボイスドラマ、映像作品は大学内外でそれぞれ企画を持ち込み、撮影を行っています。また、地元局のラジオに出演することもあります。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemaebroadcast?t=YFLj7xh-R7SACC9uW5W9KA&s=09　',
        instagram: 'https://www.instagram.com/otemae_housou?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
        youtube: 'https://www.youtube.com/@Otemae.broadcast',
      },
    },
    {
      id: 'literature',
      name: '文芸部',
      pic: ['club_b_img11.jpg'],
      text: `普段はDiscordで交流し、主にさくら祭や大手前祭までに作品を制作し、発表しています。作品は小説・詩・エッセイ・コラム等文字を使用するものをジャンルを問わず作成しています。`,
      record: ``,
      sns: {
        x: 'https://x.com/Otemae_Bunngei',
        instagram: '',
      },
    },
    {
      id: 'comic',
      name: '漫画研究部',
      pic: ['club_b_img12.jpg'],
      text: `イラストや漫画を描いて活動しています。学園祭の時期には、部誌の発行や物販なども行います。部員と意見を出し合い、楽しく活動を続けることを目標にしています。`,
      record: ``,
      sns: {
        x: 'https://x.com/otemae_manken_',
        instagram: '',
      },
    },
    {
      id: 'brass_band',
      name: '吹奏楽部',
      pic: ['club_b_img13.jpg'],
      text: `少人数ながら、私たちならではのサウンドを大切にし、楽しく活動しています。色々なジャンルの曲に挑戦して日々練習に励んでいます。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otm_windorchestra/profilecard/?igsh=NmVsNnp3ZXN3Mmt4',
      },
    },
    {
      id: 'english',
      name: 'English Club Otemae',
      pic: ['club_b_img14.jpg'],
      text: `レクリエーションや会話を通じて、実践的な英語を“楽しく”身につけることを主眼に置いて活動しています。今後はお花見やピクニックなどの校外活動の頻度も増やすことを計画中。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/english_club_otemae_eco',
      },
    },
    {
      id: 'kendo',
      name: '剣道同好会',
      pic: ['img_kendo_01.jpg'],
      text: `剣道同好会は、礼儀や精神力、諦めない心を育むことを目的とした部活動です。初心者から経験者まで幅広く受け入れ、基本技から防具を使った練習まで行います。活動日は週1回（土曜日or日曜日）で、体育館で練習します。短い稽古時間で集中して技術を磨き、部員同士の絆も強く、互いに切磋琢磨する環境が整っています。高校時代に剣道を始めた部員が多く、大学から始めた学生も活躍しています。ぜひ見学に来てください！`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae.kendo/',
      },
    },
    {
      id: 'soft_tennis',
      name: 'ソフトテニス同好会',
      pic: ['club_d_img02.jpg'],
      text: `初心者・経験者を問わず、ソフトテニスに興味あるメンバーがテニスを楽しむ同好会です。`,
      record: ``,
      sns: {
        x: '',
        instagram: '',
      },
    },
    {
      id: 'hyogen',
      name: '表現制作同好会',
      pic: ['img_hyogen_01.jpg', 'img_hyogen_02.jpg'],
      text: `演劇・舞台をはじめ、映画や音楽など様々な表現を制作する同好会です。役者はもちろん、大道具、裏方の輝ける場所を提供したいと考えています。モットーは 楽しくみんなで！`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/ootemae_hyogenseisaku/?igsh=Zjl5OGZ1c3VrY3h4#',
      },
    },
    {
      id: 'outdoor',
      name: 'アウトドアサークル',
      pic: ['club_d_img05.jpg'],
      text: `月1回のペースで、主にアウトドアですが室内での活動もしています。半年から1年に1回の大きなイベントと、他の都道府県への一泊旅行も予定しています。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_outdoor/profilecard/?igsh=YzlnbTZ6dmpxdzRm',
      },
    },
    {
      id: 'accounting',
      name: '会計学研究部',
      pic: ['club_d_img06.jpg'],
      text: `日商簿記等の資格取得をめざして活動しています。初めて勉強する人も仲間とともに切磋琢磨できる環境を共に作り、資格取得をめざして活動しています。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/otemae_caiken/profilecard/?igsh=MW45aGJ0dXl3bGFqYg==',
      },
    },
    {
      id: 'oasis',
      name: 'OASIS',
      pic: ['club_d_img07.jpg'],
      text: `OASIS 日本語サークルは、日本語教師を目指す人はもちろん、
      「留学生と友達になりたい！」
      「日本語を教えてみたい！」
      「日本人の友達がほしい！」
      「日本生活のあれこれ、気軽に相談したい！」
      そんなあなたを大歓迎！
      まるでオアシスのように、ほっと一息つける楽しい交流の場です!
      語学力アップも、友達づくりも、ここで一緒に楽しみましょう！`,
      record: ``,
      sns: {
        x: 'https://x.com/otemaeoasis',
        instagram: 'https://www.instagram.com/oasis_nihongo_otemaedaigaku/profilecard/',
      },
    },
    {
      id: 'net_design',
      name: 'ネットデザインサークル',
      pic: ['club_d_img08.jpg'],
      text: `ネットを活用した様々な宣伝活動や、オリジナルキャラクターを用いた創作物などをサイトに公開しています。`,
      record: ``,
      sns: {
        x: '',
        instagram: 'https://www.instagram.com/net_design_otemae/',
      },
    },
    {
      id: 'metaverse',
      name: 'メタバースサークル',
      pic: ['club_d_img09.jpg'],
      text: `メタバースやバーチャルリアリティ、それに用いられる技術についての造詣を深め、メタバースを知らない人に興味を持ってもらえるよう活動を行っています。普段はVRChatというVRSNSを使って活動。他大学との交流もあります。`,
      record: ``,
      sns: {
        x: '',
        instagram: '',
      },
    },
  ];

  return clubList;
}
